import { render } from "./DashboardStep.vue?vue&type=template&id=d0c4feac&scoped=true"
import script from "./DashboardStep.vue?vue&type=script&lang=js"
export * from "./DashboardStep.vue?vue&type=script&lang=js"

import "./DashboardStep.vue?vue&type=style&index=0&id=d0c4feac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c4feac"]])

export default __exports__